<template>
	<div class="full box">
		<component :key="moduleKey" :is="formModule.component" :param="formModule.param" @submit="submit" />
	</div>
</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 10px 10px;
		overflow: auto;
	}

	.item {
		flex-direction: row;
		align-items: center;
	}
</style>
<script>
	export default {
		props: {
			param: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				moduleKey: Math.random(),
				formModule: {
					component: null,
					param: null,
				}
			}
		},
		watch: {

		},
		created() {
			
		},
		mounted() {
			this.module()
		},
		computed: {

		},
		methods: {
			module(){
				//console.log(`@/views/scan/${this.param.module + '/'+ this.param.action}/index.vue`)
				import(`@/views/scan/${this.param.module + '/'+ this.param.action}/index.vue`).then((res) => {
					this.formModule = {
						component: res.default,
						param: this.param.param,
					}
				},()=>{
					this.$message.error('业务模块不存在')
				})
			},
			submit(e) {
				this.$emit('submit',e)
			}
		},
		components: {

		}
	}
</script>